import type { JSX, ReactNode } from 'react';
import { useMemo } from 'react';
import type { CustomControlCode } from '@common/enums';
import type { ProcessActivityEditContextValue } from './processActivityEditContext';
import { ProcessActivityEditContext } from './processActivityEditContext';

type ProcessActivityEditProviderProps<
    Data extends Record<string, unknown> = Record<string, unknown>,
    TCustomControlCode extends CustomControlCode | undefined = undefined,
    Version extends number = 1,
> = ProcessActivityEditContextValue<Data, TCustomControlCode, Version> & {
    readonly children: ReactNode;
};

export function ProcessActivityEditContextProvider<
    Data extends Record<string, unknown> = Record<string, unknown>,
    TCustomControlCode extends CustomControlCode | undefined = undefined,
    Version extends number = 1,
>(props: ProcessActivityEditProviderProps<Data, TCustomControlCode, Version>): JSX.Element {
    const { children, ...contextValueProps } = props;
    const contextValue = useMemo(
        () => contextValueProps as ProcessActivityEditContextValue,
        Object.values(contextValueProps)
    );

    return <ProcessActivityEditContext.Provider value={contextValue}>{children}</ProcessActivityEditContext.Provider>;
}
